export const sv = {
  anonymousCustomer: 'Anonym kund',
  noComment: 'Ingen kommentar',
  yourReply: 'Ditt svar',
  edit: 'Redigera',
  replyPlaceholder: 'Skriv ett svar till kunden…',
  saving: 'Sparar…',
  saveReply: 'Spara svar',
  cancel: 'Avbryt',
  reply: 'Svara',
  title: 'Recensioner',
  subtitle: 'Se vad kunderna tycker och svara på deras omdömen',
  reviewSingular: 'recension',
  reviewPlural: 'recensioner',
  empty: 'Inga recensioner ännu',
  loading: 'Laddar…',
  showMore: 'Visa fler',
  errSaveReply: 'Kunde inte spara svaret. Försök igen.',
}

export const en: typeof sv = {
  anonymousCustomer: 'Anonymous customer',
  noComment: 'No comment',
  yourReply: 'Your reply',
  edit: 'Edit',
  replyPlaceholder: 'Write a reply to the customer…',
  saving: 'Saving…',
  saveReply: 'Save reply',
  cancel: 'Cancel',
  reply: 'Reply',
  title: 'Reviews',
  subtitle: 'See what customers think and reply to their reviews',
  reviewSingular: 'review',
  reviewPlural: 'reviews',
  empty: 'No reviews yet',
  loading: 'Loading…',
  showMore: 'Show more',
  errSaveReply: 'Could not save the reply. Try again.',
}
